<template>
    <form class="auth-form auth-form--register" id="f-reg-webinar" @submit.prevent="handleRegisterForm()" novalidate>
        <h1 class="auth-form__title">utwórz konto</h1>

        <div class="auth-form__grid">
            <form-input
                label="Imię:"
                v-model="name"
                :modelValue="name"
                type="text"
                name="name"
                :errorMessages="errorMessages"
                placeholder="Imię..."
            ></form-input>

            <form-input
                label="Nazwisko:"
                v-model="last_name"
                :modelValue="last_name"
                type="text"
                name="last_name"
                :errorMessages="errorMessages"
                placeholder="Nazwisko..."
            ></form-input>

            <form-input
                label="Adres e-mail:"
                v-model="email"
                :modelValue="email"
                :register="true"
                type="email"
                name="email"
                :errorMessages="errorMessages"
                placeholder="email..."
            ></form-input>

            <form-input
                label="Telefon:"
                v-model="phone"
                :modelValue="phone"
                type="phone"
                name="phone"
                :errorMessages="errorMessages"
                placeholder="Telefon..."
            ></form-input>

            <div class="auth-form__field-stack">
                <form-input
                    label="Hasło:"
                    v-model="password"
                    :modelValue="password"
                    type="password"
                    name="password"
                    :errorMessages="errorMessages"
                    placeholder="Hasło..."
                ></form-input>
                <p class="auth-form__hint">* hasło musi składać się z przynajmniej 8 znaków</p>
            </div>

            <form-input
                label="Powtórz hasło:"
                v-model="password_confirm"
                :modelValue="password_confirm"
                type="password"
                name="password_confirm"
                :errorMessages="errorMessages"
                placeholder="Powtórz hasło..."
            ></form-input>

            <form-select
                label="Wykonywany zawód:"
                name="profession"
                :modelValue="profession"
                v-model="profession"
                :errorMessages="errorMessages"
                :values="parsedProfessions"
                placeholder="Wykonywany zawód..."
            ></form-select>

            <form-input
                v-if="showPwz"
                label="Numer prawa wykonywania zawodu:"
                v-model="pwz_number"
                :modelValue="pwz_number"
                type="text"
                name="pwz_number"
                :errorMessages="errorMessages"
                placeholder="Numer prawa wykonywania zawodu..."
            ></form-input>

            <form-input
                v-if="showWorkPlace"
                label="Miejsce pracy:"
                v-model="work_place"
                :modelValue="work_place"
                type="text"
                name="work_place"
                :errorMessages="errorMessages"
                placeholder="Miejsce pracy..."
            ></form-input>

            <form-input
                v-if="profession == 1"
                label="Specjalizacja:"
                v-model="specialization"
                :modelValue="specialization"
                type="text"
                name="specialization"
                :errorMessages="errorMessages"
                placeholder="Specjalizacja..."
            ></form-input>

            <form-input
                v-if="profession == 4"
                label="Uniwersytet:"
                v-model="university"
                :modelValue="university"
                type="text"
                name="university"
                :errorMessages="errorMessages"
                placeholder="Uniwersytet..."
            ></form-input>

            <form-input
                v-if="profession == 4"
                label="Numer legitymacji studenckiej:"
                v-model="card"
                :modelValue="card"
                type="text"
                name="card"
                :errorMessages="errorMessages"
                placeholder="Numer legitymacji studenckiej..."
            ></form-input>

            <form-input
                v-if="profession == 6"
                label="Firma, której jesteś przedstawicielem:"
                :modelValue="company_represented"
                type="text"
                name="company_represented"
                v-model="company_represented"
                :error-messages="errorMessages"
                placeholder="Firma..."
            ></form-input>
        </div>

        <div class="auth-form__invoice">
            <h2 class="auth-form__invoice-heading">Dane do faktury</h2>

            <form-user-type
                v-model="user_type"
                name="user_type"
                :modelValue="user_type"
                :errorMessages="errorMessages"
            ></form-user-type>

            <div class="auth-form__grid" v-if="user_type">
                <form-input
                    :disactive="user_type === 'person'"
                    :modelValue="company_name"
                    label="Nazwa firmy:"
                    v-model="company_name"
                    type="text"
                    name="company_name"
                    :errorMessages="errorMessages"
                    placeholder="Nazwa firmy..."
                ></form-input>

                <form-input
                    :disactive="user_type === 'person'"
                    :modelValue="nip"
                    label="NIP:"
                    v-model="nip"
                    type="text"
                    name="nip"
                    v-mask="[/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]"
                    :errorMessages="errorMessages"
                    placeholder="NIP..."
                ></form-input>

                <form-input
                    label="Ulica:"
                    v-model="street"
                    :modelValue="street"
                    type="text"
                    name="street"
                    :errorMessages="errorMessages"
                    placeholder="Ulica..."
                ></form-input>

                <form-input
                    label="Kod pocztowy:"
                    v-model="post_code"
                    :modelValue="post_code"
                    type="text"
                    name="post_code"
                    :errorMessages="errorMessages"
                    placeholder="Kod pocztowy..."
                ></form-input>

                <form-input
                    label="Numer mieszkania:"
                    v-model="flat_number"
                    :modelValue="flat_number"
                    type="text"
                    name="flat_number"
                    :errorMessages="errorMessages"
                    placeholder="Numer mieszkania..."
                ></form-input>

                <form-input
                    label="Numer domu:"
                    v-model="house_number"
                    :modelValue="house_number"
                    type="text"
                    name="house_number"
                    :errorMessages="errorMessages"
                    placeholder="Numer domu..."
                ></form-input>

                <form-input
                    label="Miasto:"
                    v-model="city"
                    :modelValue="city"
                    type="text"
                    name="city"
                    :errorMessages="errorMessages"
                    placeholder="Miasto..."
                ></form-input>
            </div>
        </div>

        <div class="auth-form__agreements">
            <form-user-agreement-input
                :require="1"
                :label="privacy_agreement_label"
                :modelValue="privacy_agreeement"
                v-model="privacy_agreeement"
                name="privacy_agreeement"
                :error-messages="errorMessages"
            ></form-user-agreement-input>
            <form-user-agreement-input
                :require="0"
                :label="marketing_agreement_label"
                :modelValue="marketing_agreeement"
                v-model="marketing_agreeement"
                name="marketing_agreeement"
                :error-messages="errorMessages"
            ></form-user-agreement-input>
        </div>

        <div class="auth-form__alert" v-if="professionError">
            <p>Wystąpił błąd przetwarzania formularza:</p>
            <ul>
                <li v-html="errorMessages.profession[0]"></li>
            </ul>
        </div>

        <div class="auth-form__submit-wrap">
            <vue-simple-spinner v-if="processing"></vue-simple-spinner>
            <button v-else type="submit" class="auth-form__submit">Załóż konto</button>
        </div>
    </form>
</template>

<script>
import FormInput from "./formInput";
import FormSelect from "./formSelect";
import Spinner from "vue-simple-spinner";
import FormUserType from "./formUserType";
import FormAgreementInput from "./formAgreementInput";
import FormUserAgreementInput from "./formUserAgreementInput";

export default {
    props: [
        "agreement_inputs",
        "privacy_agreement_content",
        "marketing_agreement_content",
        "professions",
    ],

    components: {
        FormUserType,
        FormAgreementInput,
        FormInput,
        FormSelect,
        FormUserAgreementInput,
        Spinner,
    },
    data() {
        return {
            email: null,
            password: null,
            password_confirm: null,
            name: null,
            last_name: null,
            profession: null,
            specialization: null,
            pwz_number: null,
            company_name: null,
            street: null,
            card: null,
            university: null,
            user_type: "person",
            house_number: null,
            flat_number: null,
            city: null,
            post_code: null,
            nip: null,
            work_place: null,
            errorMessages: null,
            successStatus: null,
            processing: false,
            company_represented: null,
            phone: null,
            professionError: false,
            agreements: [],
            specialAgreementInputs: [],
            privacy_agreeement: 0,
            marketing_agreeement: 0,
            privacy_agreement_label: this.privacy_agreement_content,
            marketing_agreement_label: this.marketing_agreement_content,
        };
    },

    computed: {
        parsedProfessions() {
            try {
                return typeof this.professions === "string"
                    ? JSON.parse(this.professions)
                    : this.professions || {};
            } catch (e) {
                return {};
            }
        },
        showPwz() {
            const professionsWithPwz = [1, 2, 3, 5, 7, 10, 11, 14];
            return professionsWithPwz.includes(Number(this.profession));
        },
        showWorkPlace() {
            return (
                this.profession != null &&
                this.profession != 4 &&
                this.profession != 6
            );
        },
    },

    methods: {
        handleRegisterForm() {
            axios
                .post("/api/register", {
                    email: this.email,
                    password: this.password,
                    password_confirm: this.password_confirm,
                    name: this.name,
                    last_name: this.last_name,
                    profession: this.profession,
                    specialization: this.specialization,
                    pwz_number: this.pwz_number,
                    company_name: this.company_name,
                    street: this.street,
                    card: this.card,
                    university: this.university,
                    house_number: this.house_number,
                    flat_number: this.flat_number,
                    city: this.city,
                    post_code: this.post_code,
                    nip: this.nip,
                    work_place: this.work_place,
                    user_type: this.user_type,
                    company_represented: this.company_represented,
                    phone: this.phone,
                    privacy_agreeement: this.privacy_agreeement,
                    marketing_agreeement: this.marketing_agreeement,
                })
                .then(() => {
                    this.processing = true;
                })
                .then(() => {
                    this.processing = false;
                    window.location.href = "/podziekowanie";
                })
                .catch((error) => {
                    this.errorMessages = error.response.data.errors;
                    if (error.response.data.errors.profession) {
                        this.professionError = true;
                    }
                })
                .then(() => {
                    const errorEl = document.querySelector(".form-field__error, .auth-form__alert, .error");
                    if (errorEl) {
                        window.scrollTo(0, errorEl.getBoundingClientRect().top + window.scrollY - 100);
                    }
                });
        },
    },
};
</script>
